export enum CustomErrorCode {
  DuplicateName = "duplicate-name",
}

export type RejectionReasons = {
  [errorCode: string]: boolean;
};